"use client";

import { authCopy } from "@/features/auth/content/auth-copy";
import { useAppLocale } from "@/features/localization/app-locale-provider";

export function AuthDivider() {
  const { locale } = useAppLocale();
  const copy = authCopy[locale];

  return (
    <div
      aria-label={copy.signIn.divider}
      className="flex items-center gap-4 text-sm text-muted-foreground"
      role="separator"
    >
      <span className="h-px flex-1 bg-border" />
      <span aria-hidden="true" className="px-1">{copy.signIn.divider}</span>
      <span className="h-px flex-1 bg-border" />
    </div>
  );
}
